import { SurveyCreatePage } from './survey.create.page';

export default SurveyCreatePage;
